module.exports = __webpack_public_path__ + "static/img/bai.f8d9fa2f.gif";